var App = App || {};

App.BorderHeadingOverlap = (function () {
    'use strict';

    function Init() {

        const objects = [
            {
                component: ".component-card-promos.carousel",
                target: ".component-card-promos-rich-text > h2:first-child",
                breakpoints: []
            },
            {
                component: ".component-contact",
                target: ".component-contact-rich-text > h2:first-child",
                breakpoints: ["xs", "sm"]
            },
            {
                component: ".item-rate-promo",
                target: ".item-rate-promo-title",
                breakpoints: []
            },
            {
                component: ".item-heroRateLockup",
                target: ".item-heroRateLockup-heading",
                breakpoints: []
            },
            {
                component: ".component-ssTabs .component-ssTabs-border",
                target: ".component-ssTabs-nav",
                breakpoints: ["xxl", "xl", "lg", "md"]
            }
        ];

        objects.forEach((obj) => Execute(obj));
        $(window).on("resize", function () { objects.forEach((obj) => Execute(obj)); });
    }

    function Execute(obj) {

        const bp = ZAGFramework.GetCurrentBP();

        $(obj.component).each(function () {

            const target = $(this).find(obj.target);

            if (obj.breakpoints.length == 0 || obj.breakpoints.includes(bp)) {
                RemoveStyles(target);
                AddStyles(target);
            }
            else {
                RemoveStyles(target);
            }
        });
    }

    function RemoveStyles(target) {
        target.removeClass("border-overlap-target").removeAttr("style");
        const html = target.children(".border-overlap-wrap").html();
        target.html(html);
    }

    function AddStyles(target) {

        let fontSize = target.css("fontSize");
        fontSize = fontSize.substring(0, fontSize.length - 2);
        const position = target.position().top;
        const marginTop = (fontSize * .95 + position) * -1;

        target
            .addClass("border-overlap-target")
            .css({ marginTop: marginTop })
            .wrapInner("<span class=\"border-overlap-wrap\">");
    }


    return {
        Init: Init
    };

})();

$(function () {
    App.BorderHeadingOverlap.Init();
});